export default "__VITE_ASSET__BxoTLqJm__"